module.exports = __webpack_public_path__ + "img/item_Story_14.cfa81c71.jpeg";